import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, onMounted, provide } from 'vue';
import { useRoute, useRouter } from 'vue-router/composables';
import {
  NavBar,
  ContextColorProvider,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel
} from '@warrenbrasil/nebraska-web';
import { Hero, HeroContainer } from '@/modules/common/components/Hero';
import { Header } from './components/Header';
import { Orders } from './components/Orders';
import { Performance } from './components/Performance';
import { Allocation } from './components/Allocation';
import { About } from './components/About';
import { BackButton } from '@/modules/common/components/buttons';
import { ShowMoneyToggleButton } from '@/modules/common/components/buttons/ShowMoneyToggleButton';

import { BffInvestments } from '@/modules/wallet-builder/src/services/bff-investments';
import { IPortfolioDistributionResponse } from '@/modules/wallet-builder/src/services/types/models/IBffInvestments';
import { getPortfolioBalance } from '@/modules/wealth/services/investment/investment';
import { IBalance } from '@/modules/wealth/services/investment/investment-types';
import { PortfolioModule } from '@/store/modules/PortfolioModule';
import { GoalType } from '@/types/models/Portfolio';

import { WealthPortfolioTabsIndexes } from './types';


export default /*#__PURE__*/_defineComponent({
  __name: 'WealthPortfolioV2',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const bffInvestments = new BffInvestments();

const isPortfolioDistributionLoading = ref(true);
const hasPortfolioDistributionError = ref(false);
const portfolioDistribution = ref<IPortfolioDistributionResponse | null>(null);

const isPortfolioBalanceLoading = ref(true);
const hasPortfolioBalanceError = ref(false);
const portfolioBalance = ref<IBalance | null>(null);
const reloadCause = ref('');
const currentTabIndex = ref(WealthPortfolioTabsIndexes.Performance);

const portfolioId = computed(() => {
  const { id } = route.params;

  return id;
});

const hasHistoryCut = computed(() => {
  return portfolioBalance.value?.hasHistoryCut || false;
});

const historyCutDate = computed(() => {
  return portfolioBalance.value?.historyCutDate?.formatted || '';
});

const isPrivatePension = computed(() => {
  return (
    portfolioDistribution.value?.portfolio?.goal === GoalType.PRIVATE_PENSION
  );
});

const portfolioImages = computed(() => {
  return {
    full: portfolioDistribution.value?.portfolio?.background?.full,
    regular: portfolioDistribution.value?.portfolio?.background?.regular,
    small: portfolioDistribution.value?.portfolio?.background?.small
  };
});

async function fetchPortfolioDistribution() {
  isPortfolioDistributionLoading.value = true;
  hasPortfolioDistributionError.value = false;

  try {
    const portfolio = await bffInvestments.getPortfolioDistribution(
      portfolioId.value
    );
    portfolioDistribution.value = portfolio;
  } catch (error) {
    hasPortfolioDistributionError.value = true;
  } finally {
    isPortfolioDistributionLoading.value = false;
  }
}
async function fetchPortfolioBalance() {
  isPortfolioBalanceLoading.value = true;
  hasPortfolioBalanceError.value = false;

  try {
    const data = await getPortfolioBalance(portfolioId.value);

    portfolioBalance.value = data.portfolioBalance;
  } catch (e) {
    hasPortfolioBalanceError.value = true;
  } finally {
    isPortfolioBalanceLoading.value = false;
  }
}

async function fetchPortfolioDetails(reloadCauseParam?: string) {
  reloadCauseParam && (reloadCause.value = reloadCauseParam);
  await Promise.all([fetchPortfolioDistribution(), fetchPortfolioBalance()]);
}

function onChangeTab(selectedTabIndex: WealthPortfolioTabsIndexes) {
  currentTabIndex.value = selectedTabIndex;
}

function handleGoBackClick() {
  router.push({ name: 'wealth' });
}

onMounted(async () => {
  await PortfolioModule.fetchPortfolios();

  const isValidPortfolio = PortfolioModule.portfolios.some(
    portfolio => portfolio.id === portfolioId.value
  );

  if (!isValidPortfolio) {
    router.push({ name: 'wealth' });
    return;
  }

  await fetchPortfolioDetails();
});

provide('portfolioDistribution', portfolioDistribution);
provide('isPortfolioDistributionLoading', isPortfolioDistributionLoading);
provide('reloadCause', reloadCause);

return { __sfc: true,route, router, bffInvestments, isPortfolioDistributionLoading, hasPortfolioDistributionError, portfolioDistribution, isPortfolioBalanceLoading, hasPortfolioBalanceError, portfolioBalance, reloadCause, currentTabIndex, portfolioId, hasHistoryCut, historyCutDate, isPrivatePension, portfolioImages, fetchPortfolioDistribution, fetchPortfolioBalance, fetchPortfolioDetails, onChangeTab, handleGoBackClick, NavBar, ContextColorProvider, Tabs, TabList, Tab, TabPanels, TabPanel, Hero, HeroContainer, Header, Orders, Performance, Allocation, About, BackButton, ShowMoneyToggleButton }
}

})